import { ICEBERG_ID } from '../data/merchant-selectors'

export function getIdsFromUrl() {
  const ret = {
    creditAppId: '',
    merchantId: ICEBERG_ID,
  }

  const pathParts = window.location.pathname.split('/').filter((x) => !!x)
  const isCreditApp = pathParts.length >= 2 && pathParts[0].toLocaleLowerCase() === 'creditapplication'

  if (isCreditApp) {
    ret.creditAppId = pathParts[1]
  } else if (pathParts.length > 0) {
    ret.merchantId = pathParts[0]
  }

  return ret
}
